/**
 * Tells if the session can start, from the result of `useGetUserStatusQuery`.
 *
 * A user with a temporary password must change it first: until then, the backend refuses every
 * request except the ones that start the session and change the password. So the session waits
 * until the status answers and the password is not temporary.
 *
 * If the status request fails, the session starts anyway, so a failing status request does not
 * lock the user out. The backend still refuses the requests of a user with a temporary password.
 * After a failed refetch, `data` keeps the last answer, so a known temporary password still
 * blocks the session.
 */
export const canStartSession = ({ data, isSuccess, isError }) =>
  (isSuccess || isError) && !data?.reset_password;
